<script>
    import { onMount, afterUpdate, createEventDispatcher } from 'svelte';
    import { functions } from './stores.js';

    export let id;
    export let session;
    export let role;
    let shareAudio;
    let screensharePreviewContainer;
    let screensharePublisher;
    let isSharing = false;
    const dispatch = createEventDispatcher();

    onMount (async()=> {

        console.log('screenshare session: ', session);
        console.log('event id: ', id);

    });

    afterUpdate(() => {
        // ...the DOM is now in sync with the data
        // let token;
        // if (session){
        //     console.log('afterUpdate session: ', session);
        //     const generateToken = $functions.httpsCallable('generateToken');
        //     generateToken({sessionId: session.id, name: `${role}-screenshare`})
        //         .then(function(result){
        //             console.log('generateToken result: ',result);
        //             // token = result.data.token;
        //             session.connect(result.data.token);

        //         });
        // };
	});

    // Recreate screenshare preview element when it gets destroyed
    function recreateScreensharePreviewEl(){
        const screensharePreviewEl = document.createElement('div');
        screensharePreviewEl.id = "screen-preview";
        screensharePreviewEl.textContent = 'screenshare preview'
        screensharePreviewContainer.appendChild(screensharePreviewEl);
    }


    async function startScreenshare(){
        console.log('start screenshare');

        OT.checkScreenSharingCapability(async function(response) {
            if(!response.supported || response.extensionRegistered === false) {
                // This browser does not support screen sharing.
            } else if (response.extensionInstalled === false) {
                // Prompt to install the extension.
            } else {
                // Screen sharing is available. Publish the screen.
                const displayMediaOptions = {
                    video: { 
                        cursor: "always",
                        logicalSurface: true,
                        frameRate: 25
                    },
                    audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        sampleRate: 44100
                    }
                }
                let captureStream=null;
                try {
                captureStream = await navigator.mediaDevices.getDisplayMedia(displayMediaOptions);
                } catch (err) {
                console.log('Error with screenshare: ',err)
                }

                if (captureStream){
                // screenshareAudioSelector.disabled = true;
                    let selectedAudio;
                    if (shareAudio === 'no'){
                        selectedAudio = null;
                    } else {
                        selectedAudio = captureStream.getAudioTracks()[0];
                    }
                    screensharePublisher = OT.initPublisher('screen-preview',
                        {videoSource: captureStream.getVideoTracks()[0],
                        audioSource: selectedAudio,
                        maxResolution: { width: 1920, height: 1080 },
                        fitMode: 'contain',
                        width: '100%',
                        height: '100%',
                        audioFallbackEnabled: false,
                        name:`${role}-screenshare`},
                        function(error) {
                        if (error) {
                            console.log('got an error when trying screen share!');
                            // Look at error.message to see what went wrong.
                            //Need to recreate screenshare preview element because it just got destroyed
                            recreateScreensharePreviewEl();
                        } else {
                            session.publish(screensharePublisher, (error) => {
                                if (error) {
                                    console.log('got an error with session publish of screenshare: ',error.message);
                                    // Look error.message to see what went wrong.
                                } else {
                                    console.log('session publish of screenshare working!', screensharePublisher);
                                    isSharing = true;
                                    // screensharePublisher.on('streamCreated', (event) => {
                                    //     console.log('publisher streamCreated! ',event);
                                    //     dispatch('streamCreated', {
                                    //         sources: {selectedAudio, selectedVideo:captureStream.getVideoTracks()[0], name:`${role}-screenshare`}
                                    //     })
                                    // });
                                    // screensharePublisher.on('destroyed', (event) => {
                                    //     console.log('publisher stream Destroyed! ',event);
                                    //     dispatch('streamDestroyed', {
                                    //         sources: {selectedAudio:null, selectedVideo:null, name:`${role}-screenshare`}
                                    //     })
                                    // });

                                        // startScreenshareBtn.style.display = "none";
                                        // stopScreenshareBtn.style.display = "block";    

                                }
                                // Not sure why streamCreated isn't being triggered.
                                // screensharePublisher.on('streamCreated', (event) => {
                                    // console.log('publisher streamCreated! ',event);
                                    dispatch('streamCreated', {
                                        sources: {selectedAudio, selectedVideo:captureStream.getVideoTracks(), name:`${role}-screenshare`, streamId:screensharePublisher.streamId }
                                    });
                                // });
                                screensharePublisher.on('streamDestroyed', (event) => {
                                    console.log('publisher stream Destroyed! ',event);
                                    dispatch('streamDestroyed', {
                                        sources: {selectedAudio:null, selectedVideo:null, name:`${role}-screenshare`}
                                    })
                                });

                            });
                        }
                    }
                );
                
                }        
                
            }

        });
    }

    async function stopScreenshare(){
        // screenshareAudioSelector.disabled = false;
        screensharePublisher.destroy();
        //need to recreate the element because it just got destroyed
        recreateScreensharePreviewEl();
        isSharing = false;
        // stopScreenshareBtn.style.display = "none";
        // startScreenshareBtn.style.display = "block";    

    }
</script>
<section id="screenshare-container">
    <div id="screenshare-controls">
        <h1>Screenshare</h1>    
        <label for="ss-audio-source-select">Screenshare Audio:</label>
        <select id="ss-audio-source-select" bind:value={shareAudio} disabled={isSharing}>
            <option value="no">No</option>
            <option value="yes">Yes</option>
        </select><br/>
        {#if isSharing}
            <button id="stop-screenshare" on:click={stopScreenshare}>
                Stop screenshare
            </button>
        {:else}
            <button id="start-screenshare" on:click={startScreenshare}>
                Start screenshare
            </button>
        {/if}
        <div id="note">*Note: When sharing a Chrome Tab, video may cut in and out.</div>
        {#if role === "host2"}
            <div id="guest-subscribe-container">
                <button id="guest-screenshare-subscribe">
                    Subscribe to Guest Screenshare
                </button>
                <button id="guest-screenshare-unsubscribe">
                    Unsubscribe to Guest Screenshare
                </button>              
                <button id="guest-camera-subscribe">
                    Subscribe to Guest Camera
                </button>
                <button id="guest-camera-unsubscribe">
                    Unsubscribe to Guest Camera
                </button>
            </div>
        {/if}
    </div>
    <div id="screen-preview-container" bind:this={screensharePreviewContainer}>
        <div id="screen-preview">Screenshare Preview</div>
    </div>
</section>

<style>
    section {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
    label {
	    display: inline-block;
    }
    #screen-preview-container {
        height: 150px;
        width: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>